import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"
import "tom-select/dist/css/tom-select.default.css"

export default class extends Controller {
  connect() {
    if (this.element.tomselect) return

    const label = this.element.getAttribute("aria-label")
    this.select = new TomSelect(this.element, {
      plugins: ["dropdown_input"],
      create: false,
      maxItems: 1,
      maxOptions: null,
      allowEmptyOption: true,
      diacritics: true,
      searchField: ["text"],
      sortField: [{ field: "$order", direction: "asc" }],
      render: {
        no_results: () => '<div class="no-results" role="status">Không tìm thấy kết quả</div>',
      },
      onInitialize() {
        this.input.setAttribute("aria-hidden", "true")
        this.focus_node.setAttribute("aria-label", label)
        this.dropdown_content.setAttribute("aria-label", label)
        this.control_input.setAttribute("aria-label", `Tìm trong ${label.toLocaleLowerCase("vi")}`)
        this.control_input.setAttribute("placeholder", "Gõ để tìm…")
      },
      onDropdownClose() {
        this.setTextboxValue("")
      },
    })
  }

  teardown() {
    if (!this.select) return

    const value = this.select.getValue()
    this.select.destroy()
    this.element.value = value
    this.select = null
    this.element.removeAttribute("aria-hidden")
  }

  disconnect() {
    this.teardown()
  }
}
